import { defineStore } from 'pinia'
import { useGlobalStore } from '~/stores/globalStore'

let timer: any = ''

export const useLocalStore = defineStore('localStore', {
  state: () => ({
    readVideoList: [] as any, //观看视频数量列表
    limitTime: 1000 * 60 * 60 * 24 //删除时间
    // limitTime: 1000 * 60 * 5 //删除时间
  }),
  // 开始数据持久化
  persist: process.client && {
    key: 'localStore',
    storage: window.localStorage,
    beforeRestore: (ctx) => {
      // console.log(`即将恢复 '${ctx.store.$id}'`)
      if (ctx.store.$id === 'localStore') {
        if (process.client) {
          if (
            window.location.pathname === '/' ||
            window.location.pathname.includes('/detail') ||
            window.location.pathname === '/launch'
          ) {
            window.localStorage.removeItem('localStore')
          }
        }
      }
    },
    afterRestore: (ctx) => {
      // console.log(`恢复完成 '${ctx.store.$id}'`)
      // ctx.store.reInitAppDataAction()
    },
    paths: ['readVideoList']
  },
  actions: {
    isScriptAlreadyIncluded(src: string) {
      const scripts = document.head.getElementsByTagName('script')
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute('src')?.includes(src)) {
          return true
        }
      }
      return false
    },
    loadScript(src: string) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = () => resolve(src)
        script.onerror = () => reject(new Error(`Failed to load script ${src}`))
        document.head.appendChild(script)
      })
    },
    //开始算时间
    async startCountdown() {
      // 检查是否是 WebClip 独立模式
      // @ts-ignore
      const isWebStand = !!window.navigator.standalone
      // 检查是否是在 WebView 或 Android 环境
      // @ts-ignore
      if (isWebView() || isWebStand) return

      // 获取全局状态管理对象
      const globalStor = useGlobalStore()
      // 当前的资源 API URL
      // @ts-ignore
      const assertApi = globalStor.currtAssertApi?.url || ''

      // 如果未加载 webWorkers.js 脚本，则动态加载
      if (!this.isScriptAlreadyIncluded('webWorkers.js')) {
        await this.loadScript(assertApi + '/js/webWorkers.js')
      }

      // 清除定时器
      window.workerTimer?.clearInterval(timer)
      timer = null

      // 如果开关关闭，则直接退出
      if (!globalStor.appConfig.watchNumSwitch) {
        return
      }

      // 设置定时器，每秒执行一次
      timer = window.workerTimer?.setInterval(() => {
        // console.log('workerTimer')
        // 过滤视频列表，移除已过期的视频
        this.readVideoList = this.readVideoList?.filter((item: any) => {
          // 如果当前时间超过指定时间限制，移除该项
          if (new Date(item.time).getTime() + this.limitTime < new Date().getTime()) {
            return false
          } else {
            return true
          }
        })
        if (!this.readVideoList?.length) {
          // 清除定时器
          window.workerTimer?.clearInterval(timer)
          timer = null
        }
      }, 5000)
    },

    //是否达到限制
    overLimit(id: string) {
      // @ts-ignore
      const isWebStand = !!window.navigator.standalone
      const globalStore = useGlobalStore()
      const { showTip } = storeToRefs(globalStore)
      const watchNumSwitch = globalStore?.appConfig?.watchNumSwitch
      const flag = !watchNumSwitch || isWebView() || isWebStand
      if (flag) {
        this.readVideoList = []
        showTip.value = false
        return showTip.value
      } else {
        const ids = this.readVideoList?.map((item: any) => item.id)
        if (ids?.includes(id)) {
          showTip.value = false
        } else {
          if (this.readVideoList?.length >= globalStore.appConfig.watchNum) {
            showTip.value = true
          } else {
            showTip.value = false
          }
        }
      }

      return globalStore.showTip
    },
    //新增
    async addVideo(id: string) {
      // @ts-ignore
      const isWebStand = !!window.navigator.standalone
      // @ts-ignore
      if (isWebView() || isWebStand || !!window.android) return
      if (this.overLimit(id)) return
      const ids = this.readVideoList?.map((item: any) => item.id)
      if (!ids?.includes(id)) {
        this.readVideoList.push({ id, time: this.formatTime(new Date()) })
      }
    },
    formatTime(date: any) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let seconds = date.getSeconds()

      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  },
  getters: {}
})
